import React from 'react';

const Logo = ({ className = "w-8 h-8" }) => {
    return (
        <svg 
            className={className} 
            viewBox="0 0 64 64" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="liquid-gold" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FCD34D" />
                    <stop offset="35%" stopColor="#F59E0B" />
                    <stop offset="100%" stopColor="#EA580C" />
                </linearGradient>
                <linearGradient id="gold-core" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#EA580C" />
                    <stop offset="50%" stopColor="#F59E0B" />
                    <stop offset="100%" stopColor="#FEF3C7" />
                </linearGradient>
                <filter id="neon-glow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="4" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
            </defs>

            {/* Glowing Aura (Liquid Gold ambient light) */}
            <circle cx="32" cy="32" r="20" fill="#F59E0B" opacity="0.15" filter="url(#neon-glow)" />

            {/* Hexagonal Outer Shell (Executive / Armor / Structure) */}
            <path 
                d="M32 4L56 18V46L32 60L8 46V18L32 4Z" 
                stroke="url(#liquid-gold)" 
                strokeWidth="3" 
                strokeLinejoin="round" 
            />
            
            {/* Inner Structural Facets (Tech/Crystal depth) */}
            <path 
                d="M32 4V28 M8 18L32 28L56 18 M8 46L32 38L56 46 M32 60V38" 
                stroke="url(#liquid-gold)" 
                strokeWidth="1.5" 
                strokeOpacity="0.4" 
                strokeLinejoin="round" 
            />
            
            {/* The "Gem" Core (Abstract G & Crystal) */}
            <path 
                d="M32 24L46 32V44L32 38L18 44V32L32 24Z" 
                fill="url(#gold-core)" 
                filter="url(#neon-glow)"
            />
            
            {/* High-end Reflection / Light Bounce on the upper-left facet */}
            <path 
                d="M32 24L18 32L32 38Z" 
                fill="#ffffff" 
                fillOpacity="0.4" 
            />

            {/* Inner "Cut" representing software injection/depth */}
            <path 
                d="M32 24V38 M18 32V44 M46 32V44" 
                stroke="#FFFFFF" 
                strokeWidth="1.5" 
                strokeOpacity="0.6"
            />
        </svg>
    );
};

export default Logo;
